import luda from '../base/luda.coffee'



luda.include

  slice: -> luda [].slice.apply(@els, arguments)